import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from '../../../components/student_layout/Topbar';
import AIAssistantFAB from '../../../components/student/AIAssistantFAB';
import '../../../student.css';


const StudentLayout = () => {
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    // Close mobile sidebar on route change
    useEffect(() => {
        setMobileOpen(false);
    }, [location]);

    return (
        <div className="flex min-h-screen bg-brand-beige dark:bg-brand-charcoal overflow-hidden">
            <Sidebar collapsed={collapsed} mobileOpen={mobileOpen} onToggle={() => setCollapsed(!collapsed)} />

            <div className="flex-1 flex flex-col h-screen overflow-hidden relative">
                <Topbar
                    role="student"
                    collapsed={window.innerWidth < 1024 ? !mobileOpen : collapsed}
                    onToggle={() => {
                        if (window.innerWidth < 1024) {
                            setMobileOpen(!mobileOpen);
                        } else {
                            setCollapsed(!collapsed);
                        }
                    }}
                />

                <main className="flex-1 overflow-y-auto p-4 md:p-8 sm:[&::-webkit-scrollbar]:w-2 md:[&::-webkit-scrollbar]:w-2">
                    <Outlet />
                </main>
            </div>

            {/* Mobile Overlay */}
            {mobileOpen && (
                <div
                    className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[45] animate-in fade-in duration-300 md:hidden"
                    onClick={() => setMobileOpen(false)}
                />
            )}

            <AIAssistantFAB />
        </div>
    );
};

export default StudentLayout;
